// extracted by mini-css-extract-plugin
export default {"footer":"layout_footer__fRUPl","inner":"layout_inner__gb3OJ","info":"layout_info__-7Mqy","logo":"layout_logo__0tBA8"};